import React from 'react';
import PropTypes from 'prop-types';

const Fallback = ({ altText }) => <svg viewBox="0 0 240 180" className="c-image__fallback">
    <title>{altText}</title>
    <g>
      <path
        d="M158.8,42.6l-15-0.7l-0.9-9.8c-0.2-2.1-2-3.5-4.2-3.3l-53.9,4.4c-2.1,0.2-3.7,1.9-3.5,4l3.9,42.9
                    c0.2,2.1,2,3.5,4.2,3.3l2.7-0.2l-0.4,8.3c-0.1,2.3,1.7,4.2,4.1,4.3l60.1,2.9c2.4,0.1,4.4-1.6,4.5-3.9l2.5-47.9
                    C163,44.6,161.2,42.7,158.8,42.6z M94.2,43.6l-1.3,24.5l-3.2,4.5l-2.9-32.4v-0.1V40c0.2-0.9,0.8-1.6,1.7-1.7l47.5-3.9
                    c0.9-0.1,1.8,0.5,1.9,1.4c0,0,0.1,0,0.1,0.1c0,0,0.1,0,0.1,0.1l0.5,5.6l-39.9-1.9C96.3,39.6,94.3,41.3,94.2,43.6L94.2,43.6z
                    M155,86.7l-15.4-18.1l-6.8,6.2l-12.6-14.7L97.8,83.9l1.9-36.2v-0.1c0.2-1,1.1-1.7,2.2-1.6l53,2.5c1.1,0.1,1.9,0.9,1.9,1.9
                    c0,0,0.1,0.1,0.1,0.1L155,86.7L155,86.7z"
      />
      <path d="M122.1,53.7c2.8,0,5.2-2.3,5.2-5.2s-2.3-5.2-5.2-5.2c-2.8,0-5.2,2.3-5.2,5.2S119.2,53.7,122.1,53.7z" />
      <g>
        <path d="M70.6,128.7l-10.2-16.1h-0.1v16.1h-2.6v-20.5h3.2l10,16h0.1v-16h2.6v20.5H70.6z" />
        <path
          d="M80.3,127.5c-1.5-1.3-2.3-3.3-2.3-6.4c0-3.1,0.7-5.2,2.2-6.4c1.4-1.2,3.2-1.6,5.1-1.6c1.9,0,3.7,0.4,5.1,1.6
                        c1.5,1.3,2.3,3.3,2.3,6.4c0,3.1-0.8,5.2-2.2,6.4c-1.4,1.2-3.2,1.6-5.1,1.6C83.5,129.1,81.7,128.7,80.3,127.5z M90,121.1
                        c0-3.9-1.4-5.9-4.6-5.9c-3.3,0-4.6,1.7-4.6,5.8c0,3.9,1.4,5.9,4.6,5.9C88.7,127,90,125.2,90,121.1z"
        />
        <path d="M105,109.9v-2.8h3v2.8H105z M107.7,128.7h-2.5v-15.1h2.7v15.1H107.7z" />
        <path
          d="M134.2,128.7V119c0-2.7-1.4-3.6-3.6-3.6c-1.3,0-2.7,0.4-4.5,1.1c0.3,0.8,0.4,1.6,0.4,2.5v9.7h-2.7V119
                        c0-2.7-1.4-3.6-3.5-3.6c-1.2,0-2.5,0.4-4.2,1v12.3h-2.7v-15.1h2.3l0.1,0.8c1.8-0.6,3.6-1.2,5.3-1.2c1.5,0,3.1,0.4,4,1.5
                        c2-0.7,4.4-1.5,6.3-1.5c1.6,0,3.2,0.5,4.2,1.7c0.9,1.1,1.1,2.5,1.1,4.2v9.7H134.2z"
        />
        <path
          d="M151.8,128.7l-0.1-0.8c-2,0.6-3.6,1.2-5.5,1.2c-1.3,0-2.6-0.3-3.5-1.2c-1-0.9-1.4-2-1.4-3.5
                        c0-1.6,0.6-3.1,2.2-4c1.1-0.6,2.3-0.7,3.9-0.7c1.1,0,2.7,0.1,4.1,0.2v-0.7c0-3-1.2-4-4.7-4c-1.2,0-2.6,0.1-3.8,0.2v-2.2
                        c1.4-0.1,2.8-0.3,4.2-0.3c2,0,4,0.2,5.4,1.5c1.3,1.2,1.5,2.9,1.5,5v9.1H151.8z M151.4,121.8c-1.2-0.1-2.8-0.2-3.9-0.2
                        c-2.7,0-3.7,1-3.7,2.7c0,1.6,1.1,2.7,3.1,2.7c1.4,0,2.9-0.5,4.5-1V121.8z"
        />
        <path
          d="M168.4,127.1c-1.5,0.5-3.1,1-4.7,1c-1.7,0-2.9-0.5-4-1.5c-1.3-1.4-1.9-3.3-1.9-6c0-2.8,0.9-5,2.4-6.2
                        c1.3-1,2.8-1.4,4.6-1.4c1.4,0,2.9,0.4,4.1,0.9l0.1-0.5h2v14.3c0,2.1-0.3,3.8-1.6,5.1c-1.4,1.5-3.8,1.7-6.1,1.7
                        c-1.5,0-3-0.1-4.4-0.2v-2.3c1.2,0.2,2.8,0.2,4,0.2c1.9,0,3.4-0.1,4.3-0.9c1-0.9,1.1-2.4,1.1-3.7V127.1z M168.4,115.9
                        c-1-0.4-2.1-0.7-3.1-0.7c-3.1,0-4.6,1.6-4.6,5.3c0,3.7,1.4,5.3,3.8,5.3c1.3,0,2.5-0.4,3.9-0.9V115.9z"
        />
        <path
          d="M181.6,129.1c-1.7,0-3.5-0.4-4.8-1.7c-1.4-1.5-2-3.7-2-6.3c0-2.5,0.6-4.9,2.3-6.4c1.2-1,2.7-1.6,4.8-1.6
                        c1.6,0,3.3,0.4,4.6,1.5c1.8,1.6,2,3.9,2,7h-10.9c0.1,3.5,1.6,5.2,4.6,5.2c1.8,0,3.7-0.4,5.7-0.9v2.1
                        C186,128.6,183.7,129.1,181.6,129.1z M181.7,115c-2.9,0-3.9,1.9-4.1,4.7h8.2C185.7,116.6,184.6,115,181.7,115z"
        />
        <path
          d="M71.9,158.7l-0.1-0.8c-2,0.6-3.6,1.2-5.5,1.2c-1.3,0-2.6-0.3-3.5-1.2c-1-0.9-1.4-2-1.4-3.5
                        c0-1.6,0.6-3.1,2.2-4c1.1-0.6,2.3-0.7,3.9-0.7c1.1,0,2.7,0.1,4.1,0.2v-0.7c0-3-1.2-4-4.7-4c-1.2,0-2.5,0.1-3.8,0.2v-2.2
                        c1.4-0.1,2.8-0.3,4.2-0.3c2,0,4,0.2,5.4,1.5c1.3,1.2,1.5,2.9,1.5,5v9.1H71.9z M71.5,151.8c-1.2-0.1-2.8-0.2-3.9-0.2
                        c-2.7,0-3.7,1-3.7,2.7c0,1.6,1.1,2.7,3.1,2.7c1.4,0,2.9-0.5,4.5-1V151.8z"
        />
        <path d="M82.5,158.7l-5.8-15.1h2.9l4.6,12.4h0.1l4.5-12.4h2.8l-5.8,15.1H82.5z" />
        <path
          d="M103.7,158.7l-0.1-0.8c-2,0.6-3.6,1.2-5.5,1.2c-1.3,0-2.6-0.3-3.5-1.2c-1-0.9-1.4-2-1.4-3.5
                        c0-1.6,0.6-3.1,2.2-4c1.1-0.6,2.3-0.7,3.9-0.7c1.1,0,2.7,0.1,4.1,0.2v-0.7c0-3-1.2-4-4.7-4c-1.2,0-2.5,0.1-3.8,0.2v-2.2
                        c1.4-0.1,2.8-0.3,4.2-0.3c2,0,4,0.2,5.4,1.5c1.3,1.2,1.5,2.9,1.5,5v9.1H103.7z M103.3,151.8c-1.2-0.1-2.8-0.2-3.9-0.2
                        c-2.7,0-3.7,1-3.7,2.7c0,1.6,1.1,2.7,3.1,2.7c1.4,0,2.9-0.5,4.5-1V151.8z"
        />
        <path d="M111.2,139.9v-2.8h3v2.8H111.2z M113.9,158.7h-2.5v-15.1h2.7v15.1H113.9z" />
        <path d="M119.6,158.7v-21.5h2.7v21.5H119.6z" />
        <path
          d="M137.5,158.7l-0.1-0.8c-2,0.6-3.6,1.2-5.5,1.2c-1.3,0-2.6-0.3-3.5-1.2c-1-0.9-1.4-2-1.4-3.5
                        c0-1.6,0.6-3.1,2.2-4c1.1-0.6,2.3-0.7,3.9-0.7c1.1,0,2.7,0.1,4.1,0.2v-0.7c0-3-1.2-4-4.7-4c-1.2,0-2.6,0.1-3.8,0.2v-2.2
                        c1.4-0.1,2.8-0.3,4.2-0.3c2,0,4,0.2,5.4,1.5c1.3,1.2,1.5,2.9,1.5,5v9.1H137.5z M137.1,151.8c-1.2-0.1-2.8-0.2-3.9-0.2
                        c-2.7,0-3.7,1-3.7,2.7c0,1.6,1.1,2.7,3.1,2.7c1.4,0,2.9-0.5,4.5-1V151.8z"
        />
        <path
          d="M156.4,157.6c-1.3,1-2.9,1.4-4.8,1.4c-1.5,0-3.1-0.3-4.4-0.9l-0.1,0.5h-1.9v-21.5h2.7v7.1
                        c1.6-0.5,3.4-1.1,5-1.1c1.7,0,3.1,0.5,4.2,1.6c1.4,1.4,2,3.6,2,6.4C159,154,158,156.4,156.4,157.6z M152.1,145.4
                        c-1.3,0-2.8,0.4-4.2,1v9.8c1,0.5,2.2,0.8,3.4,0.8c3.3,0,5-1.8,5-5.8S154.6,145.4,152.1,145.4z"
        />
        <path d="M163.1,158.7v-21.5h2.7v21.5H163.1z" />
        <path
          d="M176.5,159.1c-1.7,0-3.5-0.4-4.8-1.7c-1.4-1.5-2-3.7-2-6.3c0-2.5,0.6-4.9,2.3-6.4c1.2-1,2.7-1.6,4.8-1.6
                        c1.6,0,3.3,0.4,4.6,1.5c1.8,1.6,2,3.9,2,7h-10.9c0.1,3.5,1.6,5.2,4.6,5.2c1.8,0,3.7-0.4,5.7-0.9v2.1
                        C180.9,158.6,178.6,159.1,176.5,159.1z M176.6,145c-2.9,0-3.9,1.9-4.1,4.7h8.2C180.6,146.6,179.5,145,176.6,145z"
        />
      </g>
    </g>
  </svg>

export default Fallback;

Fallback.propTypes = {
  altText: PropTypes.string,
};

Fallback.defaultProps = {
  altText: 'A graphic showing that the product image is not available',
};
